<template>
  <el-drawer title="容器码列表" :visible.sync="drawer" :direction="direction" append-to-body :size="deawerSize"
    @close="closeDrawer">
    <div class="wrap">
      <el-form :model="searchParams">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label-position="left" class="fromItem" label="容器名称">
              <el-input v-model="queryParam.name" placeholder="请输入容器名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col style="margin-left: 15px" :span="10">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
            <!-- 添加批量打印按钮 -->
            <el-button type="primary" @click="openPrintDialog">批量打印</el-button>
            <!-- 一键同步 -->
            <el-button type="primary" @click="sync" v-if=" companyName.includes('利佳')">重置排序</el-button>
          </el-col>
        </el-row>
      </el-form>
      <commonTable style="height:700px;overflow-y:auto;" :tableData="tableData" :total="total"
        :currentPage="queryParam.pageNum" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange" @handleSelectionChange="handleSelectionChange">
        <template v-slot:table>
          <!-- 添加选择框列 -->
          <el-table-column type="selection" width="55" />
          <!-- 添加序号列 -->
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              <!-- 计算当前页的序号 -->
              {{ (queryParam.pageNum - 1) * queryParam.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" align="center" label="容器名称" />
          <el-table-column prop="handle" align="center" label="标识码" />
          <el-table-column prop="handle" align="center" label="容器码">
            <template slot-scope="scope">
              <vue-qr :id="`codeImage${scope.row.handle}`" :size="50" :margin="0" :auto-color="true" :dot-scale="1"
                :text="`${codeUrl}?h=${scope.row.handle}`" />
            </template>
          </el-table-column>
          <!-- 如果fullName 包含卷带的话 就让他显示数量 -->
          <el-table-column prop="num" align="center" label="数量" v-if="companyName.includes('五洲') && (fullName.includes('卷带') ||
           warehouseType != 0)">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,1)">{{scope.row.num||'0'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" label="数量" v-if="companyName.includes('利佳')">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,1)">{{scope.row.num||'0'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="weight" align="center" label="重量(t)" 
            v-if="companyName.includes('五洲') && !fullName.includes('卷带') && warehouseType == 0">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,0)">{{scope.row.weight||'0'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" label="重量T（半/成品）"
            v-if="companyName.includes('汇友') && warehouseType != 0">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,1)">{{scope.row.num||'0'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="weight" align="center" label="重量T（原材料）"
            v-if="companyName.includes('汇友') && warehouseType == 0">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,0)">{{scope.row.weight||'0'}}</el-button>
            </template>
          </el-table-column>

          <el-table-column prop="isPrint" align="center" label="是否打印">
            <!-- 1-是 0-否 -->
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.isPrint == 1">是</el-button>
              <el-button type="text" v-if="scope.row.isPrint == 0">否</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="printNum" align="center" label="打印次数" />
          <el-table-column prop="sorting" align="center" label="排序" />
          <el-table-column align="center" width="200" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="editCode(scope.row)">编辑</el-button>
              <el-button type="text" style="color: red" @click="delCode(scope.row)">删除</el-button>
              <el-button type="text" @click="printSingle(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </template>
      </commonTable>

    </div>
    <el-dialog title="详情" :visible.sync="dialogTableVisible" modal-append-to-body append-to-body>
      <el-table :data="gridData">
        <el-table-column v-if="warehouseType==2" property="orderNo" label="订单号" align="center"></el-table-column>
        <el-table-column property="className" label="产品类别" align="center"></el-table-column>
        <el-table-column property="partNumber" label="件（图）号" align="center"></el-table-column>
        <el-table-column property="modelNo" label="型号" align="center"></el-table-column>
        <el-table-column property="inventCode" label="存货编码" align="center"></el-table-column>
        <el-table-column property="specName" label="规格" align="center"></el-table-column>
        <el-table-column v-if="warehouseType == 1" property="num"
          :label="companyName.includes('汇友') ? '重量T（半/成品）' : '数量'" align="center"></el-table-column>
        <!--        <el-table-column property="className" label="类别" align="center"></el-table-column>-->
        <el-table-column v-if="warehouseType == 0" property="weight"
          :label="companyName.includes('汇友') ? '重量T（原材料）' : '重量(t)'" align="center"></el-table-column>
        <el-table-column v-if="warehouseType == 0" property="num" label="数量" align="center"></el-table-column>
        <el-table-column v-if="warehouseType == 2" property="num"
          :label="companyName.includes('汇友') ? '重量T（半/成品）' : '数量'" align="center"></el-table-column>
      </el-table>
    </el-dialog>

    <store-code-edit ref="codeEdit" @getList="getList"></store-code-edit>
    <store-code-print ref="codePrint"></store-code-print>
    <!-- 添加 index 范围输入弹窗 -->
    <el-dialog title="输入打印范围" :visible.sync="printDialogVisible" width="60%" append-to-body>
      <el-form :model="printRange">
        <el-form-item label="起始 序号">
          <el-input v-model.number="printRange.startIndex"></el-input>
        </el-form-item>
        <el-form-item label="结束 序号">
          <el-input v-model.number="printRange.endIndex"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="printDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handlePrintRange">打印</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
  import VueQr from "vue-qr";
  import { get } from "@/utils/request";
  import commonTable from "@/components/common/commonTable";
  import html2canvas from "html2canvas";
  import { fetchWarehouseDetail,updateContainerSorting } from '@/api/storeWarehouse.js'
  import StoreCodeEdit from "./storeCodeEditDialog.vue";
  import StoreCodePrint from "../../storeCode/component/codePrint.vue";
  import { codeUrl } from '@/utils/constant'
  import { deleteCode } from '@/api/storeCode.js'
  export default {
    components: { VueQr, commonTable, StoreCodeEdit, StoreCodePrint },
    data() {
      return {
        codeUrl: codeUrl,
        drawer: false,
        direction: 'rtl',
        deawerSize: 1000,
        tableData: [],
        warehouseId: '',
        total: 1,
        queryParam: {
          pageSize: 10,
          pageNum: 1,
          type: 2,
          parentId: 0,
          search: '',
          name: '',
          warehouseId: ''
        },
        warehouseType: '',
        searchParams: {
          name: ''
        },
        dialogTableVisible: false,
        gridData: [],
        numShow: true,
        fullName: '',
        multipleSelection: [], // 存储选中的行
        printDialogVisible: false,
        printRange: {
          startIndex: 1,
          endIndex: 1
        },
        userInfo: '',
        companyName: '',
      };
    },
    mounted() {
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }
      if(this.userInfo.companyName){
        this.companyName = this.userInfo.companyName
      }
    },
    methods: {
      handleClose(done) {

      },
      reset() {
        this.queryParam.name = ''
        this.getList()
      },
      openDialog(data) {
        console.log(data.fullName);
        this.fullName = data.fullName
        this.warehouseType = data.warehouseType
        this.warehouseId = data.id
        this.queryParam.warehouseId = this.warehouseId
        this.getList()
        this.drawer = true
      },
      getList() {
        fetchWarehouseDetail(this.queryParam).then(res => {
          this.tableData = res.data.list.map(row => {
            console.log(row);

            return row;
          });
          console.log("this.tableData", this.tableData);
          this.total = res.data.total;
        });
      },
      handleSizeChange(num) {
        this.queryParam.pageSize = num
        this.queryParam.pageNum = 1
        this.getList();
      },
      handleCurrentChange(num) {
        this.queryParam.pageNum = num
        this.getList();
      },
      downTwo(row) {
        let dom = document.getElementById('codeImage' + row.id);
        html2canvas(dom).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          if (dataURL !== "") {
            let a = document.createElement('a')
            a.download = row.fullName + '.png';
            a.href = dataURL;
            a.click()
          }
        })
      },
      closeDrawer() {
        this.$emit('getList')
      },
      codeDetail(row, type) {
        console.log(type);
        console.log("全部的数据", row);
        console.log("发送的数据", row.classVos);
        this.gridData = row.classVos;
        if (type == 0) {
          console.log("收到的数据", this.gridData);
          // this.gridData = this.gridData.map(item => {
          //             // 获取长宽高
          //             // 密度
          //             let density =item.density;
          //             // 长
          //             let length =item.length;
          //             // 宽度
          //             let width =item.width;
          //             // 厚度
          //             let thickness =item.thickness;
          //             let quantity = item.num; // 假设数量字段为 quantity
          //             const lengthInMeters = length / 1000; // 假设输入为毫米
          //             const widthInMeters = width / 1000;   // 假设输入为毫米
          //             const thicknessInMeters = thickness / 1000; // 假设输入为毫米

          //             const volume = lengthInMeters * widthInMeters * thicknessInMeters;
          //             const singleWeight = volume * density;
          //             let totalWeight = singleWeight * quantity;
          // // totalWeight保留3为小数
          //             totalWeight = totalWeight.toFixed(3);
          //             item.weight = totalWeight;
          //             return item;
          // });


        }
        this.dialogTableVisible = true;
      },
      editCode(row) {
        this.$refs.codeEdit.getAllClass(row.codeType == 0 ? 1 : 0)
        this.$refs.codeEdit.getClassList(row.id)
        this.$refs.codeEdit.init(row)
      },
      handleSelectionChange(selection) {
        this.multipleSelection = selection;
        // console.log('当前选中行:', this.multipleSelection);
      },
      // printAll() {
      //   this.$refs.codePrint.init('', '', 'all', this.warehouseId)
      // },
      printAll() {
        const selectedIds = this.multipleSelection.map(item => item.id);
        // 检查是否有选中项
        if (selectedIds.length === 0) {
          this.$message({
            message: '请先选择需要批量打印的容器码',
            type: 'warning',
          });
          return;
        }
        // console.log("selectedIds", selectedIds);
        this.$refs.codePrint.init('', '', 'all', this.warehouseId, selectedIds);
      },

      printSingle(row) {
        this.$refs.codePrint.init('', row.id, 'single', '')
      },
      delCode(row) {
        let params = {
          codeId: row.id
        }
        this.$confirm('此操作将永久删除该容器码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCode(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {

        })
      },
      // 打开打印范围输入弹窗
      openPrintDialog() {
        this.printDialogVisible = true;
      },
      // 处理打印范围
      async handlePrintRange() {
        const { startIndex, endIndex } = this.printRange;
        // 校验输入范围
        if (startIndex < 1 || endIndex < startIndex || endIndex > this.total) {
          this.$message({
            message: `最少1条, 最多${this.total}条数据，请重新输入`,
            type: 'warning'
          });
          return;
        }
        let params = {
          start: startIndex,
          end: endIndex,
          warehouseId: this.warehouseId
        }
        try {
          const res = await fetchWarehouseDetail(params);
          console.log("打印范围数据", res.data.list);
          this.printDialogVisible = false;
          this.$refs.codePrint.init('', '', 'all', this.warehouseId, res.data.list.map(row => row.id));
        } catch (error) {
          this.$message({
            message: '获取数据失败，请重试',
            type: 'error'
          });
        }
      },
      async sync() {
        try {
          const allDataParams = {
            ...this.queryParam,
            pageNum: 1,
            pageSize: this.total // 设置为总条数获取全部数据
          };

          const res = await fetchWarehouseDetail(allDataParams);
          const allTableData = res.data.list;

          // 构建需要更新排序的数据列表
          const sortList = allTableData.map((row, index) => {
            return {
              id: row.id,
              sorting: index + 1 // 全局排序从1开始
            };
          });

          console.log("全部数据排序列表:", sortList);

          // TODO: 调用更新排序的接口
          await updateContainerSorting({ syncCodeList: sortList });

          this.$message.success('排序重置成功');
          this.getList(); // 重新获取当前页数据

        } catch (error) {
          this.$message.error('排序重置失败，请重试');
        }
      }
    }
  };
</script>
<style scoped>
  .wrap {
    padding: 20px;
  }

  .class_item {
    font-size: 16px;
    text-align: center;
  }
</style>